'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Indicator": "Polaris-Indicator",
  "pulseIndicator": "Polaris-Indicator--pulseIndicator"
};

exports.default = styles;
